//=====================================================================
// Handler for grouped accordians
//=====================================================================
export const groupedAccordianHandler = (groupOfAccordians, toggleAccordianState) => {
    groupOfAccordians.forEach(group => {
        // Remove existing handler if present
        if (group._clickHandler) {
            group.removeEventListener('click', group._clickHandler);
        }

        const groupContainsToggle = group.matches('[data-accordianGroup="switch"]');
        const toggleAccordian = group.querySelector('[data-accordianToggle]');
        const groupType = group.getAttribute('data-accordianGroup') || null;

        // Reset the checkbox (toggle switch) on page load
        if (groupContainsToggle && toggleAccordian) {
            const openOnload = toggleAccordian.matches('[data-accordianToggle="open"]');
            toggleAccordian.setAttribute('aria-expanded', openOnload ? 'true' : 'false');
            toggleAccordian.checked = openOnload;
        }

        // Check all the group items are active
        const checkAllActiveInGroup = (accordianInsideGroup) => {
            return accordianInsideGroup.every(item => item.classList.contains("accordianIsActive"));
        }

        //=====================================================================
        // Event Listener Function for group of accordians
        //=====================================================================
        const clickHandler = (event) => {

            // Limit to the closest accordion group
            const currentGroup = event.target.closest('[data-accordianGroup]');
            if (currentGroup !== group) return; // Ignore nested groups

            const accordionsInGroup = Array.from(currentGroup.querySelectorAll(':scope > [data-accordian]'));
            const buttonsInGroup = Array.from(currentGroup.querySelectorAll(':scope > [data-accordianButton]'));
            const target = event.target;

            // Handle toggle button click
            if (groupContainsToggle && target === toggleAccordian) {
                const expanded = toggleAccordian.checked ? 'true' : 'false';
                toggleAccordian.setAttribute('aria-expanded', expanded);

                accordionsInGroup.forEach(acc => {
                    const accordionButton = acc.querySelector('[data-accordianButton]');
                    if (accordionButton) {
                        accordionButton.setAttribute('aria-expanded', expanded);
                        acc.classList[toggleAccordian.checked ? 'add' : 'remove']('accordianIsActive');
                    }
                });
                return;
            }

            // Handle individual accordion clicks
            accordionsInGroup.forEach(accordion => {
                const accordionButton = accordion.querySelector('[data-accordianButton]');

                //if (!accordionButton || target !== accordionButton) return;
                if (target !== accordionButton) return;

                const isActive = accordion.classList.contains("accordianIsActive");

                if (groupType === "alternative") {
                    accordionsInGroup.forEach(acc => acc.classList.remove('accordianIsActive'));
                    buttonsInGroup.forEach(btn => btn.setAttribute('aria-expanded', 'false'));
                }

                toggleAccordianState(accordionButton, accordion, isActive);

                if (groupContainsToggle && toggleAccordian) {
                    toggleAccordian.checked = checkAllActiveInGroup(accordionsInGroup);
                    toggleAccordian.setAttribute('aria-expanded', toggleAccordian.checked ? 'true' : 'false');
                }
            });
        };

        // Store handler reference for cleanup
        group._clickHandler = clickHandler;
        group.addEventListener('click', clickHandler);
    });
}